const getErrorMessage = (err) =>
  err?.response?.body?.message ??
  'There was an issue. Please review and try again';

export default getErrorMessage;
